import { EventBus } from "./events/eventBus";
import { VariablesStore } from "./variables/store";
import { createActionDispatcher } from "./actions/registry";
import { LEGACY_ACTION_ALIASES } from "./actions/legacyAliases";
import { createWishlistPromiseApi } from "./actions/wishlistPromiseApi";
/**
 * Build a webbridgeClient suitable for passing to the SDK's WebbridgeProvider.
 * Internal state (variables, event subscriptions) lives on the returned client;
 * keep a single instance across the provider's lifetime.
 */
export const createStorefrontBridgeClient = (config) => {
    const events = new EventBus();
    const variables = new VariablesStore(events, config);
    const action = createActionDispatcher({ config, variables, events });
    return {
        isInitialized: true,
        // Getter so the SDK's reducer sees the latest variables every time it
        // re-reads `webbridgeClient.variables` (which it does on every emitted
        // update event).
        get variables() {
            return variables.variables;
        },
        // The legacy camelCase methods (showToast, openScreen, wishlistItemAdd,
        // ...) forward to the action dispatcher. They were intentionally absent
        // in v0, but shared components in @tapcart/mobile-components (the
        // AddItemToWishlist drawer, ProductCard favorites) call them directly —
        // without the aliases those calls TypeError and break block code mid-
        // interaction. Mapping mirrors LEGACY_WEBBRIDGE_ACTIONS in the RN
        // provider; real implementations (wishlist ops, cart/add) do real work,
        // the rest hit the registry's graceful stubs.
        actions: Object.assign(Object.assign({}, Object.entries(LEGACY_ACTION_ALIASES).reduce((acc, [actionName, methodName]) => {
            const alias = (data, handlers) => action(actionName, data, handlers);
            acc[methodName] = alias;
            return acc;
        }, { action })), createWishlistPromiseApi(action)),
        registerEventHandler: (eventName, callback) => events.register(eventName, callback),
        mobile: {
            // Legacy stub. The SDK's WebbridgeProvider patches `mobile.load` during
            // its initialization handshake; in web mode the handshake is a no-op
            // because `isInitialized` is already true at construction time.
            load: () => { },
        },
        setCustomer: (customer) => variables.setCustomer(customer),
    };
};
